module.exports = __webpack_public_path__ + "static/media/user.f4654476.svg";